module.exports = __webpack_public_path__ + "img/JNJqrcode_bg.48e52e3b.png";